export default {
  search: 'Search',
  operation: 'Operation',
  edit: 'Edit',
  submit: 'Submit',
  re_edit: 'Re-edit',
  confirm: 'Confirm',
  cancel: 'Cancel',
  close: 'Close',
  open: 'Open',
  drag_file_here: 'Drag the file here, or ',
  click_it_upload: 'Upload',
  set: 'Set',
  change: 'Change',
  next: 'Next',
  previous: 'Previous',
  update: 'Update',
  detail: 'Detail',
  show: 'Show',
  send: 'Send Code',
  re_send: 'Re-Send',
  re_set: 'Reset',
  retry: 'Retry',
  view: 'View',
  clear: 'Clear',
  modify: 'Modify',
  login_out: 'Login Out',
  home: 'Home',
  amount: 'Amount',
  amount_to_receive: 'Amount to Receive',
  amount_non_negative: 'Please enter a non-negative number',
  amount_integer_only: 'Please enter an integer amount, only integers are supported',
  amount_two_decimal_places: 'Please enter two decimal places',
  date: 'Date',
  time: 'Time',
  create_time: 'Create Time',
  transaction_date: 'Transaction Date',
  start_date: 'Start Date',
  end_date: 'End Date',
  status: 'Status',
  link: 'Link',
  add: 'Add',
  copy: 'Copy',
  download: 'Download',
  handle: 'Handle',
  success: 'Success',
  back: 'Back',
  total: 'Total',
  delete: 'Delete',
  create: 'Create',
  email: 'Email',
  operator: 'Operator',
  tips: 'Tips',
  operation_time: 'Operation Time',
  last_operator: 'Last Operator',
  proceed: 'Proceed',
  notification: 'Notification',
  reason: 'Reason',
  create_payment: 'Create Payment',
  refund: 'Refund',
  transaction_country: 'Transaction Country',
  complete_time: 'Complete Time',
  filter: 'Filter',
  activity: 'Activity',
  select: 'Select',
  selected: 'Selected',
  banks: 'Banks',
  view_details: 'View Details',
  time_zone: 'Time Zone',
  refresh: 'Refresh',
  type: 'Type',
  yes: 'Yes',
  no: 'No',
  click_to_upload: 'Upload',
  action: 'Action',
  cancel_withdraw: 'Cancel Withdraw',
  save: 'Save'
}
